import { isCEP } from '@convenia/helpers'

import { mapCep } from '../mappers/addressContacts'

export default (ctx) => ({
  zipCode: {
    type: 'text',
    label: 'CEP',
    placeholder: 'CEP',
    mask: '#####-###',
    validation: { min: 9 },
    validationMsg: 'Informe um CEP válido.',
    emitPreValidation: true,
    onInput: async (formData, value) => {
      if (!isCEP(value)) return

      const [ err, data ] = (await ctx?.getZipCode?.(value)) || []

      if (err || !data) return

      Object.assign(formData, mapCep(data))
      ctx?.getCities?.(formData.stateId)
    },
  },

  address: {
    type: 'text',
    label: 'Endereço',
    placeholder: 'Endereço',
  },

  number: {
    type: 'text',
    label: 'Número',
    placeholder: 'Número',
    validation: 'max:50',
    validationMsg: 'Máximo de 50 caracteres.',
    emitPreValidation: true,
  },

  complement: {
    type: 'text',
    label: 'Complemento',
    placeholder: 'Complemento',
  },

  district: {
    type: 'text',
    label: 'Bairro',
    placeholder: 'Bairro',
    validation: { max: 50 },
    validationMsg: 'Máximo de 50 caracteres.',
    emitPreValidation: true,
  },

  stateId: {
    type: 'select',
    label: 'UF',
    placeholder: 'UF',
    value: '',
    displayBy: 'name',
    trackBy: 'id',
    nullable: true,
    options: [],
    optionsSrc: 'states',
    searchable: true,
    onInput: (formData, value) => {
      if (value) ctx?.getCities?.(value)

      formData.cityId = null
    },
  },

  cityId: {
    type: 'select',
    label: 'Cidade',
    placeholder: 'Cidade',
    nullable: true,
    displayBy: 'name',
    trackBy: 'id',
    optionsSrc: 'cities',
    options: [],
    searchable: true,
    isDisabled: (formData) => !formData?.stateId,
  },

  countryId: {
    type: 'select',
    label: 'País',
    placeholder: 'País',
    nullable: true,
    displayBy: 'name',
    trackBy: 'id',
    options: [],
    optionsSrc: 'countries',
    searchable: true,
  },

  documentFiles: {
    type: 'file',
    label: '',
    showLabel: false,
    multiple: true,
    labelLeft: false,
    fullWidth: true,
    extensions: [
      'jpg',
      'jpeg',
      'gif',
      'bmp',
      'png',
      'pdf',
    ],
    infoCardProps: { hide: true },
    fileLimit: 4,
    validation: { maxLength: 4 },
    sizeLimit: 8,
  },
})
